import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  buttonRoot: {
    height: "40px",
  },
  formHelperText: {
    marginLeft: "0px",
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}))

export default styles
